export const FORECAST_CONSTANTS = Object.freeze({
  MIN_FORECAST_DAYS: 3,
  MAX_FORECAST_DAYS: 45,
  MIN_WINDOW_DAYS: 15,
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_HISTORY_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
  CHECKLIST_STEPS: [
    "Initialize Forecast Engine",
    "Load Historical Data",
    "Process Inventory Metrics",
    "Calculate Demand Forecasts",
    "Generate Order Recommendations",
    "Finalize Results",
  ],

  // Execution Step Messages
  EXECUTION_STEP_MESSAGES: {
    INITIALIZE_FORECAST_ENGINE: "Initialize Forecast Engine",
    LOAD_HISTORICAL_DATA: "Load Historical Data",
    PROCESS_INVENTORY_METRICS: "Process Inventory Metrics",
    CALCULATE_DEMAND_FORECASTS: "Calculate Demand Forecasts",
    CALCULATE_RETINA_FORECASTS: "Calculate Retina Forecasts",
    GENERATE_ORDER_RECOMMENDATIONS: "Generate Order Recommendations",
    FINALIZE_RESULTS: "Finalize Results",
  },

  // Execution Step Error Messages
  EXECUTION_ERROR_MESSAGES: {
    FAILED_INITIALIZE_FORECAST_ENGINE: "Failed to initialize forecast engine",
    FAILED_LOAD_HISTORICAL_DATA: "Failed to load historical data",
    FAILED_PROCESS_INVENTORY_METRICS: "Failed to process inventory metrics",
    FAILED_CALCULATE_DEMAND_FORECASTS: "Failed to calculate demand forecasts",
    FAILED_CALCULATE_RETINA_FORECASTS: "Failed to calculate retina forecasts",
    FAILED_GENERATE_ORDER_RECOMMENDATIONS:
      "Failed to generate order recommendations",
    FAILED_FINALIZE_RESULTS: "Failed to finalize results",
  },

  // Algorithm Display Names
  ALGORITHM_DISPLAY_NAMES: {
    moving_average: "Moving Average",
    exponential_smoothing: "Exponential Smoothing",
    arima: "ARIMA",
  },

  DEMAND_FORECAST_CHECKLIST_STEPS: [
    "Extract Demand Data",
    "Prepare Mapping Tables",
    "Add Inventory & PO Details",
    "Calculate Net Drug Need",
    "Run Optimization Model",
    "Generate Practice View Output",
  ],

  DEMAND_FORECAST_CHECKLIST_STEP_MESSAGES: {
    EXTRACT_DEMAND_FROM_MEDORDER: "Extracting demand data...",
    BUILD_MAPPING_TABLES: "Preparing mapping tables...",
    ENRICH_INVENTORY_AND_PURCHASE_ORDER_DATA:
      "Adding inventory and PO details...",
    CALCULATE_NET_NEED_PER_DRUG_BY_DOSE_TYPES: "Calculating net drug need...",
    FORMULATE_AND_SOLVE_LINEAR_PROGRAMMING_PROBLEM:
      "Running optimization model...",
    GENERATE_VISUAL_OUTPUT_FOR_PRACTICE_VIEW: "Generating visual output...",
  },

  DEMAND_FORECAST_CHECKLIST_STEP_ERROR_MESSAGES: {
    FAILED_EXTRACT_DEMAND_FROM_MEDORDER: "Unable to extract demand data.",
    FAILED_BUILD_MAPPING_TABLES: "Unable to prepare mapping tables.",
    FAILED_ENRICH_INVENTORY_AND_PURCHASE_ORDER_DATA:
      "Unable to add inventory/PO details.",
    FAILED_CALCULATE_NET_NEED_PER_DRUG_BY_DOSE_TYPES:
      "Unable to calculate net drug need.",
    FAILED_FORMULATE_AND_SOLVE_LINEAR_PROGRAMMING_PROBLEM:
      "Optimization model failed.",
    FAILED_GENERATE_VISUAL_OUTPUT_FOR_PRACTICE_VIEW:
      "Unable to generate visual output.",
  },

  RETINA_FORECAST_CHECKLIST_STEPS: [
    "Extract Retina Data",
    "Prepare Mapping Tables",
    "Add Inventory & PO Details",
    "Calculate Net Drug Need",
    "Run Optimization Model",
    "Generate Practice View Output",
  ],

  RETINA_FORECAST_CHECKLIST_STEP_MESSAGES: {
    EXTRACT_RETINA_FROM_MEDORDER: "Extracting retina data...",
    BUILD_MAPPING_TABLES: "Preparing mapping tables...",
    ENRICH_INVENTORY_AND_PURCHASE_ORDER_DATA:
      "Adding inventory and PO details...",
    CALCULATE_NET_NEED_PER_DRUG_BY_DOSE_TYPES: "Calculating net drug need...",
    FORMULATE_AND_SOLVE_LINEAR_PROGRAMMING_PROBLEM:
      "Running optimization model...",
    GENERATE_VISUAL_OUTPUT_FOR_PRACTICE_VIEW: "Generating visual output...",
  },

  RETINA_FORECAST_CHECKLIST_STEP_ERROR_MESSAGES: {
    FAILED_EXTRACT_RETINA_FROM_MEDORDER: "Unable to extract retina data.",
    FAILED_BUILD_MAPPING_TABLES: "Unable to prepare mapping tables.",
    FAILED_ENRICH_INVENTORY_AND_PURCHASE_ORDER_DATA:
      "Unable to add inventory/PO details.",
    FAILED_CALCULATE_NET_NEED_PER_DRUG_BY_DOSE_TYPES:
      "Unable to calculate net drug need.",
    FAILED_FORMULATE_AND_SOLVE_LINEAR_PROGRAMMING_PROBLEM:
      "Optimization model failed.",
    FAILED_GENERATE_VISUAL_OUTPUT_FOR_PRACTICE_VIEW:
      "Unable to generate visual output.",
  },

  MODULE_SPECIALTY_KEYS: {
    DEMAND_FORECAST: ["Oncology/Hematology"],
    ALLOCATION_CHECK_LIST: ["Oncology/Hematology"],
    USAGE_FORECAST: ["Ophthalmology"],
    RETINA_FORECAST: ["Ophthalmology"],
  },

  // Export Labels
  EXPORT_LABELS: {
    EXPORT: "EXPORT",
    EXPORTING: "EXPORTING...",
    CSV: "CSV",
    EXCEL: "Excel",
    FORECAST: "Forecast",
    FINANCIAL_FORECAST: "Financial Forecast",
  },

  // Default Values
  DEFAULT_FORECAST_DAYS: 3,
  DEFAULT_PAST_USAGE_DAYS: 15,
  DEFAULT_TIMEZONE: "America/Los_Angeles",
  SUPER_USER_ROLE_ID: 6,
  USAGE_DOMAIN_NAME: "retina",
  RETINA_DOMAIN_NAME: "Retina-Demand",
  ONCOLOGY_DOMAIN_NAME: "oncology",
});
